import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { Icon } from '../icon/icon';
import { IconName } from '../icon/icon-name';

/**
 * IconButton — a chromeless icon hit-target used across toolbars, table rows
 * and inline controls. Inherits `currentColor`, so it reads white on the dark
 * topbar and dark elsewhere. Ported from the design system IconButton.
 */
@Component({
  selector: 'app-icon-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icon],
  template: `
    <button
      type="button"
      [attr.aria-label]="label()"
      [disabled]="disabled()"
      (click)="activated.emit()"
      class="inline-flex items-center justify-center rounded-control leading-none text-current transition-colors enabled:cursor-pointer enabled:hover:opacity-70 disabled:cursor-not-allowed disabled:opacity-40"
      [style.width.px]="size()"
      [style.height.px]="size()"
    >
      <app-icon [name]="icon()" [size]="size()" />
    </button>
  `,
  styles: `
    :host {
      display: inline-flex;
      line-height: 0;
    }
  `,
})
export class IconButton {
  readonly icon = input.required<IconName>();
  readonly size = input(24);
  // Required: an icon-only button is invisible to screen readers without it.
  readonly label = input.required<string>();
  readonly disabled = input(false);

  readonly activated = output<void>();
}
